import React, { Component } from 'react';
import { connect } from 'react-redux' 
import { searchActions } from '../actions';
import { SearchResult } from '../components/SearchResult';
import {
  Button,
  FormGroup,
  Input,
  Col 
} from "reactstrap";


import Select from "react-select";

var qs = require('qs');

var viewActions = require ('store/view.actions');
var Const = require ('Const');
class SearchPage extends Component {
 
  constructor(props) {
   
    super(props);
    this.state = {
      qryString: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).qry,
      qryAll: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).qryAll,
      formData: {
        search_by: 'AL'
        },
      formErrors: {
          isValid: false
      }
    }

 }

      handleInputChange = (event) => {
        this.setState({ formData : { ...this.state.formData, [event.target.name]: event.target.value} });
      }

       componentDidMount() {
          if (this.state.qryString===undefined && this.state.qryAll===undefined ) {
            this.props.getCourses( this.props.token, this.props.currentCalendarID );
            this.props.setMainTitle('Buscar', [] )
          } else if (this.state.qryString===undefined) {
            this.props.doFullSearch(this.props.token, this.props.currentCalendarID,  this.state.qryAll);
          } else {
            this.props.doSearch(this.props.token, this.props.currentCalendarID, this.state.qryString);
          }
        }

        handleInputChangeSelect = (event) =>  {
        this.setState({ formData : { ...this.state.formData, course_id: event.value, course_name: event.label} });
      }
      
      customFilter(option, searchText) {
         if (!searchText) return true ;
         if (
          option.label.substring(0,1) === searchText.substring(0,1)
        ) {
          return true;
        } else {
          return false;
        }
      }
      render() {
        
      return (
        <> 
        {this.state.qryString===undefined && this.state.qryAll===undefined ?
            <div className="content" style={{ textAlign: "-webkit-center"}}><br /><br /><br /><br />
                <h1>Qué estás buscando?</h1>
                    <Col className="text-center " sm="6">
                              <FormGroup>
                              <Select
                                  className="react-select h3 "
                                  classNamePrefix="react-select"
                                  name="search_by"
                                  isSearchable={false}
                                  defaultValue={Const.getObjectByValue(Const.SEARCH_TYPES, this.state.formData.search_by)}
                                  onChange={(sel) => this.setState({ formData : { ...this.state.formData, 'search_by': sel.value}  }) }
                                  // onChange={(sel) => this.setState({ formData : { ...this.state.formData, 'gender': sel.value}  }) }
                                  options={Const.SEARCH_TYPES}
                                  placeholder="Tipo de busqueda"
                              />
                              {this.state.formData.search_by === 'AL' || this.state.formData.search_by === 'TO' ?
                                <form action="/admin/search"  >
                                    <Input
                                        className="h3"
                                        placeholder="apellido o nombre ... "
                                        type="text"
                                        name={this.state.formData.search_by === 'AL'?"qry":"qryAll"}
                                        onChange={this.handleInputChange}
                                      />
                                      <Button
                                        type="submit"
                                        color="default"
                                        
                                      >Buscar
                                      </Button> 
                                </form>
                                  :
                                  <>
                                <Select
                                  className="react-select h3 "
                                  classNamePrefix="react-select"
                                  name="course_id"
                                  isSearchable={true}
                                  filterOption={this.customFilter}
                                  onChange={this.handleInputChangeSelect}
                                  // defaultValue={Const.getObjectByValue(Const.SEARCH_TYPES, this.state.formData.search_by)}
                                  // onChange={(sel) => this.setState({ formData : { ...this.state.formData, 'search_by': sel.value}  }) }
                                  // // onChange={(sel) => this.setState({ formData : { ...this.state.formData, 'gender': sel.value}  }) }
                                  options={this.props.courses}
                                  placeholder="buscar curso..."
                              />    
                              <Button
                                disabled={(this.state.formData.course_id===undefined) }
                                type="button"
                                color="default"
                                onClick={() => this.props.history.push("/admin/course/" + this.state.formData.course_id)}
                              >Ir {this.state.formData.course_name} 
                              </Button> 
                              </>
                            } 
                              </FormGroup>
                              
                      </Col>
                    {/* </CardBody>
                    
                  </Card> */}
          
          </div>
          :
          <SearchResult 
            personas={this.props.searchResults}
            isSearching={this.props.view.loadingModules.isSearching}
            qryString={this.state.qryString}
            qryAll={this.state.qryAll}
            />
          }
      </>
          );
    }
  }
  
  
  const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID: state.school.currentCalendarID,
        courses: state.search.courses,
        searchResults: state.search.searchResults,
        view: state.view,
    }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getCourses: ( token, calendarID )  => {
          dispatch(searchActions.getCourses(token, calendarID));
        } ,
        doSearch: (token, calendarID, qryString) => {
          dispatch(searchActions.doSearch(token, calendarID, qryString));
        } ,
        doFullSearch: (token, calendarID, qryString) => {
          dispatch(searchActions.doFullSearch(token, calendarID, qryString));
        } ,

        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle(title, menu)) ;
        }

     }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);

